import { create } from 'zustand';
import { authService } from '../services';

const useAuthStore = create((set) => ({
  utente: authService.getCurrentUser(),
  isAuthenticated: authService.isAuthenticated(),
  
  login: async (username, password) => {
    const utente = await authService.login(username, password);
    set({ utente, isAuthenticated: true });
    return utente;
  },
  
  logout: async () => {
    await authService.logout();
    set({ utente: null, isAuthenticated: false });
  },
  
  updateUser: (utente) => {
    localStorage.setItem('utente', JSON.stringify(utente));
    set({ utente });
  },
}));

export default useAuthStore;

